import { Component, Input, OnInit } from '@angular/core';

import { ColumnApi, GridOptions } from 'ag-grid-community';

import { calculateTotals } from '@program/shared/evaluations-admin-all/helpers/calculate-totals';

import { EvaluationsDisplayGridSettingService } from './evaluations-display-grid-setting.service';
import { Evaluation } from '../../evaluation/evaluation.model';
import { Total } from './totals-type';

@Component({
  selector: 'oes-evaluations-display',
  templateUrl: './evaluations-display.component.html',
  styleUrls: ['./evaluations-display.component.scss'],
  providers: [EvaluationsDisplayGridSettingService]
})
export class EvaluationsDisplayComponent implements OnInit {
  @Input() evaluations: Evaluation[];

  columnApi: ColumnApi;
  gridOptions: GridOptions;
  totals: Total;

  private gridApi: any;

  constructor(private _gridSettingService: EvaluationsDisplayGridSettingService) {
    this.gridOptions = this._gridSettingService.getGridOptions();
  }

  ngOnInit(): void {
    this.totals = calculateTotals(this.evaluations);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this._gridSettingService.setGridApi(params.api, params.columnApi);
    this.gridApi.setDomLayout('autoHeight');
    this.gridApi.setRowData(this.evaluations);
  }
}
